import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  Typography,
  Button,
  Select,
  FormControl,
  TextField,
  MenuItem,
} from "@mui/material";
import { changeStatus } from "API/swesum";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 4,
  padding: 4,
  width: "100&",
  height: "100%",
};

const Status = {
  Utkast: "0",
  Aktiv: "1",
  Pausad: "4",
  Borttagen: "3",
};

export default function StatusModal({ invoice, setInvoice, open, onClose }) {
  const [newStatus, setNewStatus] = useState(null);
  const [reason, setReason] = useState(null);
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(null);

  const { openSuccess } = usePopupNotificationContext();

  const handleConfirm = async () => {
    const body = {
      newStatus: Number(newStatus),
      reason: reason,
    };

    if (newStatus === Status.Pausad && reason === null) {
      setError("Anledning måste anges när fakturan pausas");
      return;
    }

    try {
      const res = await changeStatus(invoice?.Id, body);

      if (res) {
        setInvoice({ ...invoice, SystemStatus: newStatus });
        openSuccess("System status ändrad");
        onClose();
      }
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    const invoiceStatus = invoice?.SystemStatus;
    if (invoiceStatus == "1" || invoiceStatus == "4") {
      setOptions([Status.Aktiv, Status.Pausad]);
    } else {
      setOptions([Status.Utkast, Status.Borttagen]);
    }

    setError("");
    setNewStatus(invoiceStatus);
  }, [open]);

  return (
    <>
      <Dialog open={open}>
        <Box sx={style}>
          <Typography variant="h5" fontWeight={"bold"}>
            Ändra System Status
          </Typography>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            width={"100%"}
          >
            <FormControl fullWidth>
              <Box display="flex" gap={3} flexDirection="column">
                <Box
                  display="flex"
                  justifyContent={"center"}
                  alignItems="center"
                >
                  <Typography fontWeight={"medium"} fontSize={16} width={"50%"}>
                    Ny system status:
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={newStatus}
                      size={"small"}
                      onChange={(e) => setNewStatus(e.target.value)}
                    >
                      {options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {Object.keys(Status).find(
                            (key) => Status[key] === option
                          )}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  gap={2}
                >
                  <Typography
                    fontWeight={"medium"}
                    fontSize={16}
                    width={"100%"}
                  >
                    Notering:
                  </Typography>
                  <TextField
                    minRows={4}
                    placeholder="Notering"
                    onChange={(e) => setReason(e.target.value)}
                    multiline
                    style={{
                      minWidth: 450,
                      width: "100%",
                      borderRadius: 3,
                      border: "1px solid gray",
                    }}
                  />
                </Box>
              </Box>
            </FormControl>
          </Box>
          {error ? (
            <Box>
              <Typography color={"error"}>{error}</Typography>
            </Box>
          ) : null}
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={5}
            justifyContent={"space-around"}
            height={55}
            width={"100%"}
          >
            <Button
              sx={{
                backgroundColor: "transparent",
                outline: "1px solid #1976d2",
                color: "#1976d2",
                width: "100%",
              }}
              onClick={() => onClose()}
            >
              Avbryt
            </Button>
            <Button
              variant="contained"
              borderRadius={300}
              sx={{ backgroundColor: "#1976d2", color: "white", width: "100%" }}
              onClick={() => handleConfirm()}
            >
              Bekräfta
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
